export default __webpack_public_path__ + "assets/webgl/picking-19.81a9eb75.glb";